import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/modules/user/user.service';
import { delay } from 'src/app/shared/utils/delay';
import { AuthService } from '../../auth.service';

@Component({
    selector: 'app-validate',
    templateUrl: './validate.component.html',
    styleUrls: ['./validate.component.scss'],
})
export class ValidateComponent implements OnInit {
    form: FormGroup;

    loading: boolean = false;

    message: string = this.translate.instant('AUTH.VALIDATION-TEXT');
    statusCode: number;
    /* Alerta de erro e sucesso */
    alert = {
        show: false,
        message: '',
        type: 'success',
    };

    validationCode: string;

    get controls() {
        return this.form.controls;
    }
    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private translate: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private user: UserService
    ) {
        this.form = this.formBuilder.group({
            validationCode: new FormControl(null, Validators.required),
        });
    }

    ngOnInit(): void {
        this.getValidationCodeFromURL();
    }

    getValidationCodeFromURL() {
        this.validationCode = this.route.snapshot.queryParamMap.get('codeId');
        if (this.validationCode) {
            this.form.controls.validationCode.patchValue(this.validationCode);
        }
    }

    validate() {
        if (this.form.invalid) return;
        const {
            validationCode: { value },
        } = this.controls;
        this.authService.validateAccessCode(value).subscribe(async (response) => {
            const { description, status_code } = response;
            this.message = description;
            this.statusCode = status_code;

            if (this.statusCode === 0) {
                this.user.saveUserToLocalStorage(response.registers.login);
                this.authService.saveToken(response.token);
                await delay(2000);
                const redirectToFiliation = this.route.snapshot.queryParamMap.get('redirectAffiliation');
                if (redirectToFiliation == '1') {
                    this.router.navigate(['/user/affiliations-type']);
                } else {
                    this.router.navigate(['/home']);
                }
                // this.router.navigate(['/auth/login'], { queryParams: { email: response.registers.login.email } });
            }
        });
    }
}
